import {
	INIT_SOUND_STATUS,
} from './action-types';

export function initSoundStatusAction() {
	return {
		type: INIT_SOUND_STATUS,
	};
}
